import React, { useEffect, useState, lazy } from 'react';
import { Link } from 'react-router-dom';
import { CTAButton } from './CTAButton';
import { ArrowRightIcon, ShieldIcon } from 'lucide-react';
interface HeaderProps {
  onStartQuiz: () => void;
}
export function Header({
  onStartQuiz
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);
  // Handle scroll effect for sticky header
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // Trigger animation after component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(true);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
  return <header className={`bg-red-800 text-white px-4 py-16 md:py-24 relative transition-all duration-300 ${isScrolled ? 'shadow-lg' : ''}`} data-id="element-142">
      {/* Floating logo */}
      <div className="absolute top-4 left-4 md:left-8" data-id="element-143">
        <div className="flex items-center" data-id="element-144">
          <ShieldIcon className="h-6 w-6 text-white mr-2" data-id="element-145" />
          <span className="font-bold text-lg" data-id="element-146">HemTryggt</span>
        </div>
      </div>
      <div className="container mx-auto max-w-4xl" data-id="element-147">
        <div className="flex flex-col md:flex-row md:items-center gap-8 md:gap-12" data-id="element-148">
          <div className="md:w-3/5" data-id="element-149">
            <h1 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-150">
              Är ditt hem ett <span className="text-red-300" data-id="element-151">enkelt byte</span>{' '}
              för inbrottstjuvar?
            </h1>
            <p className="text-lg md:text-xl mb-8" data-id="element-152">
              Svara på 6 snabba frågor och upptäck dolda svagheter som kan göra
              ditt hem sårbart.
            </p>
            <div className="flex flex-col items-start" data-id="element-153">
              <Link to="/quiz" data-id="element-154">
                <CTAButton text="Ta 60-sekunders quizet" primary icon={<ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-156" />} className="transform hover:scale-105 transition-transform" data-id="element-155" />
              </Link>
              <div className="flex items-center mt-3 text-white/80" data-id="element-157">
                <svg className="w-4 h-4 mr-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-158">
                  <path d="M5 13L9 17L19 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-159" />
                </svg>
                <p className="text-sm" data-id="element-160">Helt gratis. Tar bara en minut.</p>
              </div>
            </div>
          </div>
          <div className="md:w-2/5 mt-4 md:mt-0 relative" data-id="element-161">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rLBbq5Yoau8pg35SM3ZPG4/d9c161f6-5f1e-47d5-a8c0-62956f0e3007.jpg" alt="Inbrottstjuv som försöker bryta sig in i ett hem" className="w-full rounded-lg shadow-lg" loading="lazy" data-id="element-162" />
            {/* Animated overlay */}
            {showAnimation && <div className="absolute top-3 right-3 bg-red-600 text-white text-sm py-1 px-3 rounded-full shadow-lg animate-pulse" data-id="element-163">
                67% av inbrott sker via dörr/fönster
              </div>}
          </div>
        </div>
      </div>
    </header>;
}